import React from "react";
import { T } from "../theme";

// Did the session happen? Two honest states — "Happened" / "Didn't" — because
// that is the fact the money hangs off (a block slot drawn down, or a retainer
// session rolled over). Shared by the session block and the monthly ledger.
// value: "done" | "cancelled" | "scheduled" (neither lit).
export default function HappenedToggle({ value, onSet }) {
  const btn = (key, label, onBg) => {
    const on = value === key;
    return (
      <button onClick={() => onSet(key)} style={{
        padding: "6px 11px", fontSize: 12, fontWeight: 600, border: "none", cursor: "pointer",
        fontFamily: T.fontSans, transition: "all 0.15s",
        background: on ? onBg : "transparent", color: on ? T.fgOnDark : T.fgMuted,
      }}>{label}</button>
    );
  };
  return (
    <div style={{ display: "inline-flex", borderRadius: T.radiusSm, overflow: "hidden", border: `1px solid ${T.borderSubtle}`, background: T.bgNeutral, flexShrink: 0 }}>
      {btn("done", "Happened", T.root)}
      {btn("cancelled", "Didn't", T.statusOff)}
    </div>
  );
}
